<mat-dialog-content>
    <iframe class="embed-responsive-item" [src]="url | safe:'resourceUrl'" allowfullscreen="" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>
</mat-dialog-content>